(function (app) {

    app.provider("rightBridgeApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    service.initiateRightBridgeSso = function (transactionId) {          
                        return complianceHubApiGateway.post("/RightBridgeSso/" + transactionId);
                    };
                    
                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line